import {  h,Component } from 'preact';
import { Text } from "preact-i18n";

import { Booking, Header } from "elc-basket";
import { toLocalePrice } from "elc-commons";

import {ThemeConfig} from "elc-theme";

import styles from "./BookingSummaryBasket.scss";

type BookingSummaryBasketProps = {
  config: WidgetConfig,
  order: Order,
  locale: string,
  currency: Currency,
};


export default class BookingSummaryBasket extends Component<BookingSummaryBasketProps> {

  render({ order, locale, currency }) {

    return (
      <ThemeConfig.Consumer>
        {(themeConfig) => (
              <div class={styles.basketCard}>
               
               {/* <div>{JSON.stringify(localeDefinition)}xxx</div> */}
                <Header />
                <div class={styles.basketCardContent}>
                  {order._embedded.bookings &&
                    order._embedded.bookings.map((booking) => (
                          <Booking
                          key={booking.id}
                          order={order}
                          booking={booking}
                          locale={locale}
                          currency={currency}
                        />
                  ))}
                  <div class={styles.footerPaymentContainer}>
                        <footer class={styles.footerPaiement}>
                          <h3 class={styles.totalTitle}>
                            <Text id="basket.total">Totalxxxx :</Text>
                          </h3>
                          <div
                            class={styles.price}
                            style={`color:${
                              themeConfig && themeConfig.color1
                                ? themeConfig.color1
                                : ""
                            };`}
                          >
                            <h3>
                              {toLocalePrice(
                                order.totalPrice,
                                locale,
                                currency.isoCode,
                              )}
                            </h3>
                          </div>
                        </footer>
                      </div>
                </div>
              </div>
        )}
      </ThemeConfig.Consumer>
    );
  }
}